import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-psa-supervisors',
  templateUrl: './psa-supervisors.component.html',
  styleUrls: ['./psa-supervisors.component.css']
})
export class PsaSupervisorsComponent implements OnInit {
  title="Supervisor Details";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/psadetails/psa-list/psa-supervisors/psa-supervisors.component.ts